import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import MediaQuery from 'react-responsive'
import _ from 'lodash'

import { PROFILE_PAGE } from 'utils/paths'
import { getDeadlineState, getNextDeadlinesFromPrograms } from 'components/Deadlines/helpers'
import PipelineStageButton from 'components/PipelineStageButton'
import CardActions from 'components/CardActions'
import BasicPagination from 'components/BasicPagination'
import { getPipelines } from 'store/actions/pipeline'
import ResetCardAction from 'components/CardActions/actions/ResetAction'
import ArchiveCardAction from 'components/CardActions/actions/ArchiveAction'
import HideCardAction from 'components/CardActions/actions/HideAction'
import Deadline from 'components/Deadlines'

const PipelineTable = ({
  filteredOpportunities,
  resultsPerPage,
  setResultsPerPage,
  currentPage,
  setCurrentPage
}) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const [pageStart, pageEnd] = [(currentPage - 1) * resultsPerPage, currentPage * resultsPerPage]

  return (
    <>
      <div className="Pipeline-cards__collapsed-wrapper">
        <Table className="Pipeline-cards__collapsed" padding="none">
          <TableHead>
            <TableRow>
              <TableCell>{t.cards.funderName}</TableCell>
              <TableCell>{t.cards.requestSize}</TableCell>
              <TableCell>{t.cards.upcomingDeadline}</TableCell>
              <TableCell>{t.cards.pipelineStage}</TableCell>
              <TableCell>{/* Action */}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody displayRowCheckbox={false}>
            {filteredOpportunities.slice(pageStart, pageEnd).map((opportunity, index) => {
              const funderPrograms = opportunity.funder.funderPrograms

              const { hasOngoingDeadline, closestDeadlineDate } =
                getNextDeadlinesFromPrograms(funderPrograms)

              const {
                color: cardColor,
                showDate,
                label
              } = getDeadlineState({
                deadlineDate: closestDeadlineDate,
                isOngoing: hasOngoingDeadline
              })

              const deadlineLabel =
                hasOngoingDeadline && !closestDeadlineDate.isValid
                  ? label
                  : !!closestDeadlineDate &&
                    showDate && <Deadline format="short" date={closestDeadlineDate} />

              return (
                <TableRow key={opportunity.id} className={cardColor}>
                  <TableCell>
                    <Link to={`${PROFILE_PAGE}/${opportunity.funder.id}`}>
                      {opportunity.funder.name}
                    </Link>
                  </TableCell>
                  <TableCell>
                    {opportunity.requestSize &&
                      opportunity.requestSize.trim() !== '' &&
                      opportunity.requestSize}
                  </TableCell>
                  <TableCell>{deadlineLabel}</TableCell>
                  <TableCell>
                    <PipelineStageButton
                      buttonClass="Full-card__status"
                      opportunity={opportunity}
                      funderId={opportunity.funder.id}
                      loadData={() => getPipelines(false)}
                    />
                  </TableCell>
                  <TableCell>
                    <CardActions
                      opportunityId={opportunity.id}
                      actions={[
                        ResetCardAction,
                        !opportunity.hidden && !opportunity.archived && ArchiveCardAction,
                        !opportunity.hidden && HideCardAction
                      ]}
                      loadData={() => getPipelines(false)}
                    />
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </div>
      <MediaQuery query="(min-width: 990px)">
        <BasicPagination
          pagerSize={5}
          resultCount={filteredOpportunities.length}
          viewsPerPage={resultsPerPage}
          pageNumber={currentPage}
          onNumberOfResultsChange={setResultsPerPage}
          onSetPage={setCurrentPage}
        />
      </MediaQuery>
      <MediaQuery query="(max-width: 991px)">
        <BasicPagination
          pagerSize={3}
          resultCount={filteredOpportunities.length}
          viewsPerPage={resultsPerPage}
          pageNumber={currentPage}
          onNumberOfResultsChange={setResultsPerPage}
          onSetPage={setCurrentPage}
        />
      </MediaQuery>
    </>
  )
}

export default PipelineTable
